module.exports = __webpack_public_path__ + "static/media/16UNODC21.9f468de0.jpg";